import React from 'react'
import PrivateRoutes from './PrivateRoutes'
import { Route, Routes } from 'react-router-dom'
import MainPanel from '../ProtectPages/AdminPanel/MainPanel'
import LoginPage from '../PublicPages/LoginPage'
import PrivateRoutList from './PrivateRoutList'
import CheckAuthPage from '../PublicPages/CheckAuthPage'

const RouteManager = () => {

    return (
        <div>
            <Routes>
                <Route element={<PrivateRoutes />}>
                    <Route path='Dashboard' element={<MainPanel />}>
                        {PrivateRoutList && PrivateRoutList.map((route, index) => (
                            <Route key={index} path={route.path} element={route.element}>
                                {route.children && route.children.map((child, idx) => (
                                    <Route key={idx} path={child.path} element={child.element} >


                                    </Route>
                                ))}
                            </Route>
                        ))}</Route>
                </Route>

                <Route path='login' element={<LoginPage />}></Route>
                <Route path='CheckAuth/:key/:roleName' element={<CheckAuthPage />}></Route>
                <Route element={<LoginPage />} path="*" />
            </Routes>

        </div>
    )

}

export default RouteManager